module.exports = __webpack_public_path__ + "img/carrer.1867094b.png";